// 全局函数，用于初始化单个礼品选项容器
function initGiftOption(giftContainer) {
    if (!giftContainer) return;

    const productId = giftContainer.dataset.productId;

    // 从数据属性获取 ID - 仅用于初始化和对比
    const NO_GIFT_VARIANT_ID = giftContainer.dataset.noGiftVariantId;
    const GIFT_VARIANT_ID = giftContainer.dataset.giftVariantId;
    const GIFT_OPTION_NAME = giftContainer.dataset.giftOptionName;
    const GIFT_OPTION_INDEX = parseInt(giftContainer.dataset.giftOptionIndex); // 例如 1, 2, 或 3

    // 查找元素
    const checkbox = document.getElementById(`isGiftCheckbox_${productId}`);
    const giftForm = document.getElementById(`giftCardForm_${productId}`);
    const messageTextarea = document.getElementById(`giftMessage_${productId}`);
    const charCount = document.getElementById(`charCount_${productId}`);
    const giftToInput = document.getElementById(`giftTo_${productId}`);
    const giftFromInput = document.getElementById(`giftFrom_${productId}`);

    // 隐藏的表单字段
    const giftToHidden = document.getElementById(`giftToHidden_${productId}`);
    const giftFromHidden = document.getElementById(`giftFromHidden_${productId}`);
    const giftMessageHidden = document.getElementById(`giftMessageHidden_${productId}`);
    const isGiftHidden = document.getElementById(`isGiftHidden_${productId}`);

    // ✨ 新增：查找卡片样式相关的元素
    const giftStyleHidden = document.getElementById(`giftStyleHidden_${productId}`);
    const styleRadios = giftContainer.querySelectorAll(`.gift-card-style-radio[data-product-id="${productId}"]`);

    // 查找产品表单
    let productForm = giftContainer.closest('form[action*="/cart/add"]');
    if (!productForm) {
        productForm = giftContainer.closest('form');
    }
    if (!productForm) {
        productForm = document.querySelector('form[action*="/cart/add"]');
    }

    if (!productForm) {
        // console.error(`Product ${productId}: Could not find product form.`);
        return;
    }

    // 查找变体ID输入
    let variantIdInput = productForm.querySelector('input[name="id"]');
    if (!variantIdInput) {
        variantIdInput = productForm.querySelector('select[name="id"]');
    }
    if (!variantIdInput) {
        // 创建一个隐藏的变体ID输入
        variantIdInput = document.createElement('input');
        variantIdInput.type = 'hidden';
        variantIdInput.name = 'id';
        variantIdInput.value = NO_GIFT_VARIANT_ID; 
        productForm.appendChild(variantIdInput);
    }

    /**
    * 根据当前选中的所有选项（除礼品选项外）和目标礼品选项值，查找正确的变体ID。
    * 这种方法比查询DOM更可靠。
    * @param {string} giftOptionValue - 目标礼品选项值, 'Yes' 或 'No'.
    * @returns {string|null} 找到的变体 ID 或 null.
    */
    function getUpdatedVariantId(giftOptionValue) {
        const variants = window.productVariants || [];
        if (!variants.length) {
            // console.error('window.productVariants is not defined or empty. Cannot resolve dynamic variant ID.');
            return null;
        }

        const currentVariantId = variantIdInput.value;
        if (!currentVariantId) {
            // console.warn('Could not determine the current variant ID from the form.');
            return null;
        }

        const currentVariant = variants.find(v => v.id === parseInt(currentVariantId, 10));
        if (!currentVariant) {
            // console.warn(`Could not find current variant object with ID: ${currentVariantId}`);
            // 备用方案：如果当前ID无效，尝试从表单选项中推断
            return null; 
        }

        const targetOptions = [currentVariant.option1, currentVariant.option2, currentVariant.option3].slice(0, window.productOptions.length);
        
        const giftOptionArrayIndex = GIFT_OPTION_INDEX - 1;
        if (giftOptionArrayIndex >= 0 && giftOptionArrayIndex < targetOptions.length) {
            targetOptions[giftOptionArrayIndex] = giftOptionValue;
        } else {
            // console.error(`Invalid GIFT_OPTION_INDEX: ${GIFT_OPTION_INDEX}.`);
            return null;
        }

        const matchingVariant = variants.find(variant => {
            const variantOptions = [variant.option1, variant.option2, variant.option3].slice(0, window.productOptions.length);
            return targetOptions.every((opt, index) => opt === variantOptions[index]);
        });

        if (matchingVariant) {
            // console.log(`Found matching variant for options [${targetOptions.join(', ')}]: ID ${matchingVariant.id}`);
            return matchingVariant.id.toString();
        }

        // console.warn(`No variant found for the combination: [${targetOptions.join(', ')}]`);
        return null;
    }

    // 同步输入到隐藏字段
    function syncHiddenFields() {
        if (giftToHidden) giftToHidden.value = giftToInput.value;
        if (giftFromHidden) giftFromHidden.value = giftFromInput.value;
        if (giftMessageHidden) giftMessageHidden.value = messageTextarea.value;
        if (isGiftHidden) isGiftHidden.value = checkbox.checked ? 'Yes' : 'No';
        // ✨ 新增：卡片样式的隐藏字段由它自己的监听器 (styleRadios) 处理，这里不需要
    }

    // 状态切换函数
    function toggleGiftState() {
        const isChecked = checkbox.checked;
        const targetOptionValue = isChecked ? 'Yes' : 'No';

        updateVariantSelectors(isChecked);
        
        const newVariantId = getUpdatedVariantId(targetOptionValue);
        if (newVariantId) {
            variantIdInput.value = newVariantId;
            // console.log(`Variant ID updated to: ${newVariantId}`);
        } else {
            // console.warn('Could not find correct variant ID. Keeping current ID.');
        }
        
        if (isChecked) {
            giftForm.classList.add('is-open');
        } else {
            giftForm.classList.remove('is-open');
            giftToInput.value = '';
            giftFromInput.value = '';
            messageTextarea.value = '';
            if(charCount) charCount.textContent = '0';
            giftToInput.classList.remove('error-highlight');
            giftFromInput.classList.remove('error-highlight');

            // ✨ 新增：取消勾选时，重置卡片样式
            if (giftStyleHidden) giftStyleHidden.value = 'No Style';
            const noStyleRadio = giftContainer.querySelector('.gift-card-style-radio[value="No Style"]');
            if (noStyleRadio) noStyleRadio.checked = true;
        }

        syncHiddenFields();
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        productForm.dispatchEvent(new Event('change', { bubbles: true }));

        window.dispatchEvent(new CustomEvent('variant:change', { 
            detail: { 
                variantId: variantIdInput.value,
                isGift: isChecked 
            } 
        }));
    }

    // 更新变体选择器
    function updateVariantSelectors(isGift) {
        const variantSelects = productForm.querySelectorAll('select[name^="options"], input[type="radio"][name^="options"]');
        const targetValue = isGift ? 'Yes' : 'No';

        variantSelects.forEach(selector => {
            const name = selector.name;
            // 假设 'Gift Wrap' 选项的 name 是 'options[Gift Wrap]' 或 'option1' 等形式
            const isGiftSelector = name.includes(`option${GIFT_OPTION_INDEX}`) || name.includes(GIFT_OPTION_NAME);

            if (isGiftSelector) { 
                if (selector.tagName === 'SELECT') {
                    if (selector.value !== targetValue) selector.value = targetValue;
                } else if (selector.type === 'radio') {
                    const targetRadio = productForm.querySelector(`input[name="${name}"][value="${targetValue}"]`);
                    if (targetRadio && !targetRadio.checked) targetRadio.checked = true;
                }
            }
        });
    }

    // 事件监听器
    if (checkbox) checkbox.addEventListener('change', toggleGiftState);
    if (giftToInput) giftToInput.addEventListener('input', syncHiddenFields);
    if (giftFromInput) giftFromInput.addEventListener('input', syncHiddenFields);
    if (messageTextarea) {
        messageTextarea.addEventListener('input', function() {
            if (charCount) charCount.textContent = this.value.length;
            syncHiddenFields();
        });
    }

    // ✨ 新增：为卡片样式单选按钮添加事件监听器
    if (styleRadios.length > 0 && giftStyleHidden) {
        styleRadios.forEach(radio => {
            radio.addEventListener('change', function() {
                if (this.checked) {
                    const selectedStyle = this.value;
                    giftStyleHidden.value = selectedStyle;
                    // (可选) 触发 change 事件，以防其他脚本正在监听
                    giftStyleHidden.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        });
    }

    // 拦截表单提交
    function handleFormSubmit(e) {
        if (checkbox.checked) {
            const giftTo = giftToInput.value.trim();
            const giftFrom = giftFromInput.value.trim();

            if (giftTo === '' || giftFrom === '') {
                if(e) { e.preventDefault(); e.stopPropagation(); }
                alert('Please fill in the "To" and "From" information to complete your gift card!');
                if (giftTo === '') giftToInput.classList.add('error-highlight');
                if (giftFrom === '') giftFromInput.classList.add('error-highlight');
                return false;
            }
            
            const newVariantId = getUpdatedVariantId('Yes');
            if (newVariantId) variantIdInput.value = newVariantId;
            
            syncHiddenFields();
        } else {
            const newVariantId = getUpdatedVariantId('No');
            if (newVariantId) variantIdInput.value = newVariantId;
        }
        // ✨ 新增：卡片样式的隐藏字段 (giftStyleHidden) 已经由其自己的监听器更新，
        // ✨ 因此在标准表单提交中，它会随着 `name="properties[Gift Style]"` 自动提交。
    }

    productForm.addEventListener('submit', handleFormSubmit);

    productForm.addEventListener('change', function(e) {
        if (e.target !== checkbox && e.target.name !== 'id' && e.target.type !== 'radio' /* 忽略我们自己的radio */) {
            const targetOptionValue = checkbox.checked ? 'Yes' : 'No';
            const newVariantId = getUpdatedVariantId(targetOptionValue);
            
            if (newVariantId && variantIdInput.value !== newVariantId) {
                variantIdInput.value = newVariantId;
                variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    });

    // =================================================================
    // ======================= 核心修复开始 ==========================
    // =================================================================
    // 为了兼容使用fetch API的主题 - 在拦截器中增加产品归属判断
    if (window.fetch) {
      const originalFetch = window.fetch;
        window.fetch = function(...args) {
            const [url, options] = args;
            const urlString = url.toString();

            // 检查是否是加入购物车的请求
            if (urlString.includes('/cart/add') && options && options.method === 'POST' && options.body) {
                
                let idBeingAdded = null;
                let originalBodyData = null;

                // 1. 从请求体中提取 variant ID
                if (options.body instanceof FormData) {
                    idBeingAdded = options.body.get('id');
                } else if (typeof options.body === 'string') {
                    try {
                        originalBodyData = JSON.parse(options.body);
                        // 排除批量添加的请求
                        if (originalBodyData.items && Array.isArray(originalBodyData.items)) {
                            return originalFetch.apply(this, args);
                        }
                        idBeingAdded = originalBodyData.id;
                    } catch (e) {
                        // 解析失败，无法判断，直接放行
                        return originalFetch.apply(this, args);
                    }
                }

                // 如果请求中没有ID，直接放行
                if (!idBeingAdded) {
                    return originalFetch.apply(this, args);
                }

                // 2. 检查这个ID是否属于我们正在管理的主产品
                const isMainProductVariant = window.productVariants && window.productVariants.some(v => v.id.toString() === idBeingAdded.toString());

                // 3. 如果不属于，说明是推荐产品或其他组件的加购，立即退出拦截，让原始请求继续
                if (!isMainProductVariant) {
                    return originalFetch.apply(this, args);
                }

                // --- 如果代码执行到这里，说明这是主产品的加购请求，需要进行处理 ---
                // console.log('Gift-option: Intercepting main product ATC request.');
                handleFormSubmit(); // 运行验证和ID更新逻辑

                // -------------------- FormData 处理 --------------------
                if (options.body instanceof FormData) {
                    // variantIdInput.value 已经被 handleFormSubmit 更新
                    options.body.set('id', variantIdInput.value); 
                    
                    // 清理旧属性并根据当前状态设置新属性
                    options.body.delete('properties[To]');
                    options.body.delete('properties[From]');
                    options.body.delete('properties[Message]');
                    options.body.delete('properties[🎁]');
                    options.body.delete('properties[Gift Style]'); // ✨ 新增

                    if (checkbox.checked) {
                        options.body.set('properties[🎁]',`This is a gift`);
                        options.body.set('properties[To]', giftToInput.value.trim());
                        options.body.set('properties[From]', giftFromInput.value.trim());
                        options.body.set('properties[Message]', messageTextarea.value);
                        options.body.set('properties[Gift Style]', giftStyleHidden.value); // ✨ 新增
                    }
                }
                // -------------------- JSON Body 处理 --------------------
                else if (originalBodyData) {
                    const newBodyData = { ...originalBodyData };
                    
                    // variantIdInput.value 已经被 handleFormSubmit 更新
                    newBodyData.id = variantIdInput.value;

                    // 清理旧属性并根据当前状态设置新属性
                    newBodyData.properties = newBodyData.properties || {};
                    delete newBodyData.properties['To'];
                    delete newBodyData.properties['From'];
                    delete newBodyData.properties['Message'];
                    delete newBodyData.properties['🎁'];
                    delete newBodyData.properties['Gift Style']; // ✨ 新增

                    if (checkbox.checked) {
                        newBodyData.properties['🎁'] = ` This is a gift`;
                        newBodyData.properties['To'] = giftToInput.value.trim();
                        newBodyData.properties['From'] = giftFromInput.value.trim();
                        newBodyData.properties['Message'] = messageTextarea.value;
                        newBodyData.properties['Gift Style'] = giftStyleHidden.value; // ✨ 新增
                    }
                    // 更新请求体
                    options.body = JSON.stringify(newBodyData);
                }
            }

            return originalFetch.apply(this, args);
        };
    }
    // =================================================================
    // ======================== 核心修复结束 =========================
    // =================================================================
}

// DOM加载完成后，初始化所有礼品卡容器
document.addEventListener('DOMContentLoaded', function() {
    // 查找所有礼品卡功能容器
    const giftContainers = document.querySelectorAll('.gift-card-container');

    // **重要：请确保 window.productVariants 在此之前已经被 Liquid 赋值**
    if (typeof window.productVariants === 'undefined' || window.productVariants === null) {
        // console.error('FATAL ERROR: window.productVariants is not defined. Variant lookup will fail. Please add: <script>window.productVariants = {{ product.variants | json }};</script> to your Liquid template.');
    }
    
    giftContainers.forEach(container => {
        initGiftOption(container);
    });
});

// 导出函数供外部使用
if (typeof window !== 'undefined') {
    window.initGiftOption = initGiftOption;
}